// Colors card game data with rankings
export const COLORS_CARDS = [
  { id: 1, name: "Agreeable Gray", rank: 1, image: "/images/colors/colors_1.jpg" },
  { id: 2, name: "Snowbound", rank: 2, image: "/images/colors/colors_2.jpg" },
  { id: 3, name: "Alabaster", rank: 3, image: "/images/colors/colors_3.jpg" },
  { id: 4, name: "Repose Gray", rank: 4, image: "/images/colors/colors_4.jpg" },
  { id: 5, name: "Dover White", rank: 5, image: "/images/colors/colors_5.jpg" },
  { id: 6, name: "Accessible Beige", rank: 6, image: "/images/colors/colors_6.jpg" },
  { id: 7, name: "Star Blue", rank: 7, image: "/images/colors/colors_7.jpg" },
  { id: 8, name: "Tricorn Black", rank: 8, image: "/images/colors/colors_8.jpg" },
  { id: 9, name: "Creamy", rank: 9, image: "/images/colors/colors_9.jpg" },
  { id: 10, name: "Heron Plume", rank: 10, image: "/images/colors/colors_10.jpg" },
  { id: 11, name: "Iron Ore", rank: 11, image: "/images/colors/colors_11.jpg" },
  { id: 12, name: "White Flour", rank: 12, image: "/images/colors/colors_12.jpg" },
  { id: 13, name: "Alpaca", rank: 13, image: "/images/colors/colors_13.jpg" },
  { id: 14, name: "Sea Salt", rank: 14, image: "/images/colors/colors_14.jpg" },
  { id: 15, name: "Ivory Lace", rank: 15, image: "/images/colors/colors_15.jpg" },
  { id: 16, name: "Electric Blue", rank: 16, image: "/images/colors/colors_16.jpg" },
  { id: 17, name: "Steamy Pink", rank: 17, image: "/images/colors/colors_17.jpg" },
  { id: 18, name: "City Orange", rank: 18, image: "/images/colors/colors_18.jpg" },
  { id: 19, name: "Lemon Yellow", rank: 19, image: "/images/colors/colors_19.jpg" },
  { id: 20, name: "Purple", rank: 20, image: "/images/colors/colors_20.jpg" },
  { id: 21, name: "Paisley", rank: 21, image: "/images/colors/colors_21.jpg" },
  { id: 22, name: "Orca Black", rank: 22, image: "/images/colors/colors_22.jpg" },
  { id: 23, name: "Bugsy Gold", rank: 23, image: "/images/colors/colors_23.jpg" },
  { id: 24, name: "Silver Hue", rank: 24, image: "/images/colors/colors_24.jpg" },
  { id: 25, name: "Olive Green", rank: 25, image: "/images/colors/colors_25.jpg" },
  { id: 26, name: "Ink Jet", rank: 26, image: "/images/colors/colors_26.jpg" },
  { id: 27, name: "Starry Night", rank: 27, image: "/images/colors/colors_27.jpg" },
  { id: 28, name: "Eagle Red", rank: 28, image: "/images/colors/colors_28.jpg" },
  { id: 29, name: "Silly String", rank: 29, image: "/images/colors/colors_29.jpg" },
  { id: 30, name: "Taupe", rank: 30, image: "/images/colors/colors_30.jpg" }
];
